import React, { useState } from "react";
import { db } from "firebase/fbConfig.js";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import PrototypeExploreMapAssignUser from './PrototypeExploreMapAssignUser';

class Explore extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            query: '',
        }
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.subCollection && this.props.hinge && prevProps.hinge !== this.props.hinge) {
            this.loadData();
        }
    }

    handleChange = e => {
        this.setState({ query: e.target.value });
    }

    clearQuery = () => {
        this.setState({
            query: ''
        })
    }

    getSubCollectionData = (coll) => {
        return new Promise((resolve, reject) => {
            coll.ref.collection('users').get()
                .then(snapshot => resolve(snapshot))
                .catch(err => reject(err));
        })

        // return new Promise((resolve, reject) => {
        //     db.collection(this.props.collection).doc(id).collection('users').get()
        //         .then(response => resolve(response))
        //         .catch(err => reject(err));
        // })
    }

    getUserData = (id) => {
        return new Promise((resolve, reject) => {
            db.collection("TEST-users").doc(id).get()
                .then(user => resolve(user))
                .catch(err => reject(err))
        })
    }



    loadData = async () => {
        const { collection, collection2, subCollection, hinge } = this.props;
        const arr = [];
        if (subCollection) {

            if (hinge) {
                db.collection(collection).where('name', '==', hinge).get()
                    .then(async response => {
                        const subCollPromises = [];
                        for (let i = 0; i < response.docs.length; i++) {
                            const doc = response.docs[i];
                            // subCollPromises.push(this.getSubCollectionData(doc.id));
                            subCollPromises.push(this.getSubCollectionData(doc));
                        }
                        Promise.all(subCollPromises)
                            .then(responses => {
                                const promises = [];
                                console.log("Related users:", responses);
                                for (let i = 0; i < responses.length; i++) {
                                    const snapshot = responses[i];

                                    for (let j = 0; j < snapshot.docs.length; j++) {
                                        const id = snapshot.docs[j].id;
                                        promises.push(this.getUserData(id));
                                    }
                                }
                                Promise.all(promises)
                                    .then(usersSnapshots => {
                                        console.log("Gotten users:", usersSnapshots);
                                        for (let i = 0; i < usersSnapshots.length; i++) {

                                            if (usersSnapshots[i].exists) {

                                                const user = {
                                                    ...usersSnapshots[i].data(),
                                                    id: usersSnapshots[i].id
                                                }

                                                arr.push(user);

                                            }

                                            
                                        }
                                        console.log("users put in data:", arr)
                                        this.setState({ data: arr })
                                    })
                            })
                    })
            }

        } else {
            const promises = [db.collection(collection).get()];
            collection2 && promises.push(db.collection(collection2).get())
            Promise.all(promises)
                .then(responses => {
                    for (let i = 0; i < responses.length; i++) {
                        const docs = responses[i].docs;

                        for (let j = 0; j < docs.length; j++) {
                            const docData = {
                                ...docs[j].data(),
                                id: docs[j].id
                            }

                            arr.push(docData);
                        }

                    }

                    this.setState({ data: arr})
                })
        }
    }

    render() {
        return (
            <GridContainer style={{ backgroundColor: "#f7f3f0" }} justify="center">
                <GridItem xs={12}>

                    <CustomInput
                        labelText={this.props.labelText}
                        id={this.props.id}
                        formControlProps={{
                            fullWidth: true
                        }}
                        labelProps={{
                            shrink: true
                        }}
                        inputProps={{
                            onChange: (e) => { this.handleChange(e); this.props.onChange && this.props.onChange(e) },
                            value: this.state.query
                        }}
                    />

                </GridItem>
                <GridItem xs={12}>
                    <PrototypeExploreMapAssignUser
                        trip={this.props.trip}
                        collection={this.props.collection}
                        collection2={this.props.collection2}
                        field={this.props.field}
                        data={this.state.data}
                        subCollection={this.props.subCollection}
                        value={this.state.query}
                        hinge={this.props.hinge}
                        assignUser={this.props.assignUser}
                        stateObj={this.props.stateObj}
                        id={this.props.id}
                        vendorSelector={this.props.vendorSelector}
                        clear={this.clearQuery}
                    />
                </GridItem>
            </GridContainer>
        )
    }
}

export default Explore;


// WEBPACK FOOTER //
// ./src/views/Explore/PrototypeExploreAssignUser.jsx